/** Finite transport waiters. A Save/Close overtakes queued display work. */
export class NativeQueue {
 private work:{run:()=>Promise<unknown>;resolve:(value:any)=>void;reject:(error:unknown)=>void;bytes:number}[]=[]
 private control:typeof this.work=[]
 private active=false
 private bytes=0
 constructor(private readonly countLimit=8,private readonly byteLimit=256*1024){}
 pending(){return {work:this.work.length,control:this.control.length,bytes:this.bytes}}
 enqueue<T>(run:()=>Promise<T>,control=false,bytes=0):Promise<T>{
  if(!Number.isSafeInteger(bytes)||bytes<0||(!control&&(this.work.length>=this.countLimit||this.bytes+bytes>this.byteLimit))||(control&&this.control.length>=2))return Promise.reject(Error('The editor is busy. Wait briefly and retry. You can still save.'))
  return new Promise<T>((resolve,reject)=>{
   ;(control?this.control:this.work).push({run,resolve,reject,bytes:control?0:bytes})
   if(!control)this.bytes+=bytes
   void this.drain()
  })
 }
 private async drain(){
  if(this.active)return
  this.active=true
  try{while(this.control.length||this.work.length){const item=(this.control.length?this.control:this.work).shift()!;this.bytes-=item.bytes;try{item.resolve(await item.run())}catch(error){item.reject(error)}}}
  finally{this.active=false}
 }
}
